(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
var searchInput = document.getElementById('faqSearch');
if (!searchInput) return;

searchInput.addEventListener('input', function(e) {
var searchTerm = e.target.value.toLowerCase().trim();
var categories = document.querySelectorAll('.faq-category');
var items = document.querySelectorAll('.faq-item');
var hasResults = false;

categories.forEach(function(category) {
var categoryItems = category.querySelectorAll('.faq-item');
var categoryHasMatch = false;

categoryItems.forEach(function(item) {
var question = item.querySelector('.faq-question').textContent.toLowerCase();
var answer = item.querySelector('.faq-answer').textContent.toLowerCase();
var matches = !searchTerm || question.includes(searchTerm) || answer.includes(searchTerm);

if (matches) {
item.style.display = '';
categoryHasMatch = true;
hasResults = true;
} else {
item.style.display = 'none';
}
});

if (categoryHasMatch || !searchTerm) {
category.classList.remove('faq-hidden');
} else {
category.classList.add('faq-hidden');
}
});

var noResultsMsg = document.querySelector('.faq-no-results');
if (!hasResults && searchTerm) {
if (!noResultsMsg) {
noResultsMsg = document.createElement('div');
noResultsMsg.className = 'faq-no-results';
noResultsMsg.textContent = 'No questions match your search.';
document.querySelector('.faq-content').appendChild(noResultsMsg);
}
noResultsMsg.style.display = 'block';
} else if (noResultsMsg) {
noResultsMsg.style.display = 'none';
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stmt-header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
    }
connectedCallback() {
this.header = document.getElementById('shopify-section-stmt-header');
this.promo = document.querySelector('.js-sticky-promo');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');
// Homepage
this.promoBounds = {};
this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
this.createObserver();
if (this.promo) {
this.promoObserver();
      }
    }
disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
    }
createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
      });
observer.observe(this.header);
    }
promoObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.promoBounds = entries[0].intersectionRect;
observer.disconnect();
      });
observer.observe(this.promo);
    }
onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
if (this.promo) {
this.top = this.promoBounds.top - this.headerBounds.height;
this.bottom = this.promoBounds.bottom;
      } else {
this.top = this.headerBounds.top;
this.bottom = this.headerBounds.bottom;
      }
if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
if (scrollTop <= this.bottom || scrollTop < 100) {
requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.top) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.top) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
        } else {
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
          }, 66);
requestAnimationFrame(this.hide.bind(this));
        }
      }
this.currentScrollTop = scrollTop;
    }
hide() {
this.header.classList.add('shopify-section-stmt-header-hidden', 'shopify-section-stmt-header-sticky');
if (this.promo) {
this.scrollingPromo();
      }
this.closeMenuDisclosure();
this.closeSearchModal();
    }
reveal() {
this.header.classList.add('shopify-section-stmt-header-sticky', 'animate');
this.header.classList.remove('shopify-section-stmt-header-hidden');
    }
reset() {
this.header.classList.remove(
'shopify-section-stmt-header-hidden',
'shopify-section-stmt-header-sticky',
'animate'
      );
if (this.promo) {
this.promo.classList.remove('scrolling-bar--sticky');
      }
    }
scrollingPromo() {
this.promo.classList.add('scrolling-bar--sticky');
    }
closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach((disclosure) => disclosure.close());
    }
closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
    }
  }
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
